export interface RRIInputOption<T> {
  id: string | number;
  value: T;
  style?: { [klass: string]: any };
  hide?: boolean;
  selected?: boolean;
}
